import { Menu } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import type { MenuProps } from 'antd';
import styles from './index.module.scss';
import { useState, useEffect } from "react";
import { useGlobalStore } from "@/store";
import { useTranslation } from "react-i18next";
import { isChineseDomain } from "@/utils";
import { useUmamiTracker } from "@/hooks/useUmamiTracker";

const isChineseDomainFlag = isChineseDomain();

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  disabled?: boolean,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
    disabled
  } as MenuItem;
}

const getItems = (t, userId: string): MenuItem[] => {
  if (isChineseDomainFlag) {
    return [
      getItem(t('MyPage'), userId),
      getItem(t('Member'), 'member'),
      getItem(t('Profile'), 'profile'),
      getItem(t('Developer'), 'developer'),
    ];
  }
  return [
    getItem(t('MyPage'), userId),
    getItem(t('Profile'), 'profile'),
    getItem(t('Developer'), 'developer'),
  ]; 
};

const UserCenter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [key, setKey] = useState<string | undefined>(location.pathname.split('/').pop());
  const currentUser = useGlobalStore((state) => state.currentUser);
  const [ t ] = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  
  // 处理用户ID和默认选中项
  const userId = currentUser?.publicId || '';
  const items = getItems(t, userId);
  
  const { trackEvent } = useUmamiTracker();

  // 检测移动设备
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  
  // 页面加载时的埋点
  useEffect(() => {
    trackEvent('user_center_page_load', {});
  }, [trackEvent]);
  
  // 菜单选择的埋点
  const onSelect = ({ selectedKeys }: { selectedKeys: string[] }) => {
    const selectedKey = selectedKeys?.[0];
    trackEvent('user_center_menu_select', { 
      from: key, 
      to: selectedKey 
    });
    navigate(selectedKey);
    setKey(selectedKey);
  };

  return (
    <div className={styles.UserCenter}>
      <div className={styles.wrapper}>
        <Menu 
          className={styles.menu} 
          onSelect={onSelect}
          defaultSelectedKeys={[key || userId]}
          items={items}
          mode={isMobile ? "horizontal" : "vertical"}
        />
        <div className={styles.main}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default UserCenter;